import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "common";
import { SharedModule } from "../shared/shared.module";
import { OfferBundleListComponent } from "./offer-bundle-list/offer-bundle-list.component";
import { OfferBundleTabsComponent } from "./offer-bundle-list/components/offer-bundle-tabs/offer-bundle-tabs.component";
import { OfferBundleDetailsComponent } from "./offer-bundle-list/components/offer-bundle-details/offer-bundle-details.component";
import { OfferBundleCheckoutRequirementListComponent } from "./offer-bundle-list/components/offer-bundle-checkout-requirement-list/offer-bundle-checkout-requirement-list.component";

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule],
  declarations: [
    OfferBundleListComponent,
    OfferBundleTabsComponent,
    OfferBundleDetailsComponent,
    OfferBundleCheckoutRequirementListComponent,
  ],
})
export class OfferBundleModule {}
